export const user = {
    id: "5b8ccac0-4250-4b26-9fca-804e3a41de49",
    login: 'user@silico.fr',
    password: 'silico',
    firstname: "Julien",
    lastname: "Chenavas",
    mobile: '0675221159',
    company: 'SILICO',
};